module.exports = __webpack_public_path__ + "static/media/event-detail-color.85852eaf.svg";